import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ToastContainer, toast } from 'react-toastify';
import { connect } from 'react-redux';
import Loader from '../Loader';
import { getConfiguration } from '../../store/actions/configuration';

function notify(message) {
  toast.error(message, {
    closeOnClick: true,
    position: 'top-right',
    autoClose: 10000,
    toastId: 1, // show only one
  });
}

const SearchBox = ({ placeholder, fetchConfiguration }) => {
  const [value, setValue] = useState('');
  const [inputInfo, setInputInfo] = useState(false);
  const [loader, setLoader] = useState(false);
  const handleSubmit = e => {
    if (e.key === 'Enter' || e.tagName === 'SPAN') {
      if (value.length !== 0) {
        setLoader(true);
        fetchConfiguration(value).then(response => {
          if (response.result.status === 404) {
            notify('Podany numer konfiguracji jest nieprawidłowy.');
            setLoader(false);
          } else {
            setLoader(false);
          }
        });
      } else {
        notify('Wpisz numer konfiguracji żeby rozpocząć wyszukiwanie.');
      }
    }
  };

  return (
    <div className="container search-box">
      <div className="search-box--relative">
        <input
          className="search-box__input"
          type="search"
          onChange={e => setValue(e.target.value)}
          onFocus={() => setInputInfo(true)}
          onBlur={() => setInputInfo(false)}
          placeholder={placeholder}
          onKeyPress={e => handleSubmit(e)}
        />
        {loader ? (
          <Loader />
        ) : (
          <span className="icon-search search-box__icon" onClick={e => handleSubmit(e.target)} />
        )}
        {inputInfo && (
          <p className="search-box__text">
            <span>X</span>
            Jeżeli wygenerowałeś lub otrzymałeś plik PDF z podsumowaniem konfiguracji, tutaj możesz
            wprowadzić numer zawarty w pliku, w celu odtworzenia lub modyfikacji zapisanej
            konfiguracji.
          </p>
        )}
      </div>
      <ToastContainer />
    </div>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    fetchConfiguration: value => dispatch(getConfiguration(value)),
  };
};

SearchBox.propTypes = {
  placeholder: PropTypes.string.isRequired,
  fetchConfiguration: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(SearchBox);
